import { useTranslation } from 'react-i18next'
import HomeFilter from '../components/HomeFilter'
import AnnouncesPrivate from '../components/announces-private'
import ContactForm from '../components/ContactForm'

export default function Privatepage() {
  const { t } = useTranslation()
  return (
    <>
      <div
        id='premium-slider'
        className='text-center w-full align-middle bg-redpink text-white  py-3'
      >
        <h1 className='uppercase text-2xl'>{t('private-corner')}</h1>
        <h2 className='max-w-7xl text-sm mx-auto'>
          {t('private-corner-desc')}
        </h2>
      </div>
      <div
        id='home-filter'
        className='w-full mx-auto justify-center text-anthracite'
      >
        <HomeFilter />
      </div>
      <div
        id='announces-home'
        className='w-full mx-auto  justify-center text-anthracite'
      >
        <AnnouncesPrivate />
      </div>

      <ContactForm />
    </>
  )
}
